<template>
  <button class="tw-px-8 tw-py-6 tw-shadow-xl tw-font-bold tw-flex tw-items-center tw-bg-light tw-transition-none tw-border-b-3 tw-border-transparent" :class="{'tw-text-primary tw-border-primary' : current === value}">
    <i :class="icon" class="tw-mr-2 tw-text-4xl"></i>
    <div class="tw-text-2xl tw-font-semibold">{{title}}</div>
  </button>
</template>
<script>
  export default {
    props: {
      title: {},
      icon: {},
      current: {},
      value: {},
    }
  }
</script>
